// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics"
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import { firebaseConfig } from "utils/constants";
import { connectNotification } from "apis/notifications";
import { toast } from "react-toastify";
import { getNotifMsg } from "utils/message";
import { getBrowserNotifPermissionState } from "utils/browserNotifs";
import { FCM_TOKEN_KEY } from "constants/localStorageKeys";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase

// const analytics = getAnalytics(app);

// export const getFCMToken = () => {
//   if ("serviceWorker" in navigator) {
//     return navigator.serviceWorker
//       .register("/firebase-messaging-sw.js")
//       .then(function (registration) {
//         var config = {
//             apiKey: firebaseConfig.apiKey,
//             authDomain: firebaseConfig.authAdmin,
//              databaseURL: firebaseConfig.databaseUrl,
//              projectId: firebaseConfig.projectId,
//              storageBucket: firebaseConfig.storageBucket,
//              messagingSenderId: firebaseConfig.messagingSenderId,
//              appId: firebaseConfig.appId,
//              measurementId: firebaseConfig.measurementId,
//         };
//         const app = initializeApp(config);
//         const messaging = getMessaging(app);

//         return getToken(messaging, {
//           vapidKey:
//             firebaseConfig.vapidKey,
//         }).then(function (token) {
//           if (token) {
//             return token;
//           }
//         });
//       })
//       .catch(function (err) {});
//   }
// };

var config = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authAdmin,
  databaseURL: firebaseConfig.databaseUrl,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId,
  measurementId: firebaseConfig.measurementId,
};

const messaging = async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      const app = initializeApp(config);
      return getMessaging(app);
    }
    console.log("Firebase not supported this browser");
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const onMessageListener = async () =>
  new Promise((resolve) =>
    (async () => {
      const messagingResolve = await messaging();
      onMessage(messagingResolve, (payload) => {
        resolve(payload);
      });
    })()
  );

const getTokenWithRetry = async (retryCount = 1, messagingResolve) => {
  for (let attempt = 1; attempt <= retryCount; attempt++) {
    try {
      const currentToken = await getToken(messagingResolve, {
        vapidKey: firebaseConfig.vapidKey,
      });

      if (currentToken) {
        return currentToken;
      }
    } catch (err) {
      console.log(
        `Attempt ${attempt}: An error occurred while retrieving token.`,
        err
      );

      const SUBSCRIBE_ERROR =
        "AbortError: Failed to execute 'subscribe' on 'PushManager': Subscription failed - no active Service Worker";

      // Only retry if it's not the final attempt and it's a service worker error
      if (attempt === retryCount || err.toString() !== SUBSCRIBE_ERROR) {
        throw err;
      }
    }
  }
  return null;
};

export const getFCMToken = async () => {
  const messagingResolve = await messaging();

  try {
    return await getTokenWithRetry(3, messagingResolve); // Allow two retry
  } catch (error) {
    console.log("Final error in getFCMToken:", error);
    return null;
  }
};

const handleNotifEnableSuccess = (notif, locale, fcmToken) => {
  if (notif) {
    toast.success(getNotifMsg("NOTIFS_ENABLED", locale));
  }
  localStorage.setItem(FCM_TOKEN_KEY, fcmToken);
};

export const handleNotificationPermission = async (
  toastMsg = false,
  locale,
  setLoading = () => {}
) => {
  const notifState = getBrowserNotifPermissionState();
  const authToken = localStorage.getItem("raychat_web_app_token");

  if (!notifState) {
    console.log("This browser does not support notification");
    return;
  }

  const permissionResult = await Notification.requestPermission();

  // if user grants permission for notification
  if (permissionResult === "granted") {
    setLoading(true);

    try {
      const fcmToken = await getFCMToken();
      const notifConnectRes = await connectNotification(fcmToken, authToken);

      if (notifConnectRes.success) {
        handleNotifEnableSuccess(toastMsg, locale, fcmToken);

        return "success";
      }

      throw new Error();
    } catch (error) {
      toastMsg &&
        toast.error(getNotifMsg("ERROR_WHILE_ENABLING_NOTIFS", locale));

      setLoading(false);
    }
  }

  if (permissionResult === "denied") {
    console.log("permisson denied!!");
  }
};
